module.exports = __webpack_public_path__ + "static/media/levels_4_5.94e59254.svg";